import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setSelectedCommissionsPlan: (state: IRootState, action: PayloadAction<IRootState['selectedCommissionsPlan']>) => ({
    ...state,
    selectedCommissionsPlan: action.payload,
  }),
  setActiveStep: (state: IRootState, action: PayloadAction<IRootState['activeStep']>) => ({
    ...state,
    activeStep: action.payload,
  }),
  setCommissionPlans: (state: IRootState, action: PayloadAction<IRootState['commissionPlans']>) => ({
    ...state,
    commissionPlans: action.payload,
  }),
  setToggleDeleteDialog: (state: IRootState, action: PayloadAction<IRootState['toggleDeleteDialog']>) => ({
    ...state,
    toggleDeleteDialog: action.payload,
  }),
  setMemberEmails: (state: IRootState, action: PayloadAction<IRootState['memberEmails']>) => ({
    ...state,
    memberEmails: action.payload,
  }),
  setCommissionMode: (state: IRootState, action: PayloadAction<IRootState['commissionMode']>) => ({
    ...state,
    commissionMode: action.payload,
  }),
  setIsOpenAssignMembersNav: (state: IRootState, action: PayloadAction<IRootState['isOpenAssignMembersNav']>) => ({
    ...state,
    isOpenAssignMembersNav: action.payload,
  }),
  setCommissionsSummary: (state: IRootState, action: PayloadAction<IRootState['commissionsSummary']>) => ({
    ...state,
    commissionsSummary: action.payload,
  }),
  resetCommissionsState: (state: IRootState) => ({
    ...state,
    commissionsSummary: {} as IRootState['commissionsSummary'],
  }),
  appendToCommissionsSummary(state: IRootState, action: PayloadAction<IRootState['commissionsSummary']>) {
    // Merge new summaries into existing state
    action.payload.forEach((newSummary) => {
      const existingSummary = state.commissionsSummary.find(
        (summary) => summary.user.email === newSummary.user.email,
      );
      if (existingSummary) {
        existingSummary.productsCount += newSummary.productsCount;
        existingSummary.ordersCount += newSummary.ordersCount;
        existingSummary.totalSales += newSummary.totalSales;
        existingSummary.totalCommissions += newSummary.totalCommissions;
        existingSummary.dailyCommissions += newSummary.dailyCommissions;
      } else {
        state.commissionsSummary.push(newSummary);
      }
    });
  },
  setCommissionView: (state: IRootState, action: PayloadAction<IRootState['commissionView']>) => ({
    ...state,
    commissionView: action.payload,
  }),
  setTableCommissionView: (state: IRootState, action: PayloadAction<IRootState['tableCommissionView']>) => ({
    ...state,
    tableCommissionView: action.payload,
  }),
  setIsOpenTeamCommissionsNav: (state: IRootState, action: PayloadAction<IRootState['isOpenTeamCommissionsNav']>) => ({
    ...state,
    isOpenTeamCommissionsNav: action.payload,
  }),
  setSelectedTeam: (state: IRootState, action: PayloadAction<IRootState['selectedTeam']>) => ({
    ...state,
    selectedTeam: action.payload,
  }),
  setCommissionTeams: (state: IRootState, action: PayloadAction<IRootState['commissionTeams']>) => ({
    ...state,
    commissionTeams: action.payload,
  }),
  setIsOpenDeleteTeamDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenDeleteTeamDialog']>) => ({
    ...state,
    isOpenDeleteTeamDialog: action.payload,
  }),
  setSelectedProduct: (state: IRootState, action: PayloadAction<IRootState['selectedProduct']>) => ({
    ...state,
    selectedProduct: action.payload,
  }),
};

export {
  reducers,
};
